module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issues-category-detail",
    attrs: {
      "data-wdtype": _vm.wdtype
    }
  }, [_c('div', {
    staticClass: "issues-category-header"
  }, [_c('h2', {
    staticClass: "issues-category-title"
  }, [(_vm.newAlertCount > 0) ? _c('span', {
    staticClass: "issues-category-new-badge"
  }, [_vm._v(_vm._s(_vm.newAlertCount) + " new")]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.categoryName) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-toolbar"
  }, [_c('div', {
    staticClass: "issues-category-tabs"
  }, [(!_vm.resolvedHidden) ? _c('button', {
    class: ['issues-category-tab', {
      active: _vm.issuesListTab === 'resolved'
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('issues-tab-change', 'resolved')
      }
    }
  }, [_c('i', {
    staticClass: "check icon"
  }), _vm._v(" Resolved "), _c('span', {
    staticClass: "tab-count"
  }, [_vm._v(_vm._s(_vm.resolvedCount))])]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['issues-category-tab', 'active-tab', {
      active: _vm.issuesListTab === 'active' || _vm.resolvedHidden,
      'has-active-count': _vm.activeCount > 0
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('issues-tab-change', 'active')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activeCount) + " Active\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "issues-category-actions"
  }, [_c('div', {
    staticClass: "issues-category-marketplace-filter"
  }, [_c('i', {
    staticClass: "globe icon"
  }), _vm._v(" "), _c('select', {
    staticClass: "issues-category-marketplace-select",
    attrs: {
      "aria-label": "Filter by marketplace"
    },
    domProps: {
      "value": _vm.marketplaceColumnFilterValue
    },
    on: {
      "change": _vm.onMarketplaceColumnFilter
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All marketplaces")]), _vm._v(" "), _vm._l((_vm.marketplaceFilterOptions), function(c) {
    return _c('option', {
      key: c,
      domProps: {
        "value": c
      }
    }, [_vm._v("\n            " + _vm._s(_vm.marketplaceOptionLabel(c)) + "\n          ")])
  })], 2)]), _vm._v(" "), (_vm.wdtype === 'fbaFeeChange') ? _c('div', {
    staticClass: "issues-category-marketplace-filter"
  }, [_c('i', {
    staticClass: "sort amount down icon"
  }), _vm._v(" "), _c('select', {
    staticClass: "issues-category-marketplace-select",
    attrs: {
      "aria-label": "Sort by FBA fee change"
    },
    domProps: {
      "value": _vm.feeDirection
    },
    on: {
      "change": _vm.onFeeDirectionChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Newest first")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "increase"
    }
  }, [_vm._v("Fee increase (largest first)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "decrease"
    }
  }, [_vm._v("Fee decrease (largest first)")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "issues-category-search"
  }, [_c('i', {
    staticClass: "search icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "issues-category-search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search products..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.onSearchInput]
    }
  })]), _vm._v(" "), (_vm.wdtype === 'salesDrop') ? _c('button', {
    staticClass: "issues-category-configure-btn",
    class: {
      open: _vm.showSalesConfigurePanel
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSalesConfigurePanel
    }
  }, [_c('i', {
    staticClass: "setting icon"
  }), _vm._v("\n        Configure Thresholds\n      ")]) : _vm._e(), _vm._v(" "), (_vm.wdtype === 'competitivePrice') ? _c('button', {
    staticClass: "issues-category-configure-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.exportingChangeLog,
      "title": "Every change of Amazon's competitive price in the last 30 days (CSV per storefront)"
    },
    on: {
      "click": _vm.exportChangeLog
    }
  }, [_c('i', {
    class: _vm.exportingChangeLog ? 'notched circle loading icon' : 'download icon'
  }), _vm._v("\n        Export change log\n      ")]) : _vm._e(), _vm._v(" "), (_vm.exportChangeLogError) ? _c('p', {
    staticClass: "issues-category-export-error"
  }, [_vm._v(_vm._s(_vm.exportChangeLogError))]) : _vm._e(), _vm._v(" "), (_vm.canMarkAllResolved) ? _c('button', {
    staticClass: "issues-category-configure-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.bulkResolveInProgress
    },
    on: {
      "click": _vm.markAllResolved
    }
  }, [(_vm.bulkResolveInProgress) ? _c('i', {
    staticClass: "notched circle loading icon"
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.itemsMeta && _vm.itemsMeta.total_pages > 1 ? 'Mark page as resolved' : 'Mark all as resolved') + "\n      ")]) : _vm._e()])]), _vm._v(" "), (_vm.wdtype === 'salesDrop') ? [(_vm.showSalesConfigurePanel && !_vm.salesVolumeThresholdPanelDataReady) ? _c('div', {
    staticClass: "sales-volume-thresholds-prefetch-bar",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('span', [_vm._v("Loading sales volume thresholds…")])]) : _vm._e(), _vm._v(" "), (_vm.showSalesConfigurePanel) ? _c('div', {
    class: {
      'sales-volume-thresholds-panel-wrap--prefetch': !_vm.salesVolumeThresholdPanelDataReady
    }
  }, [_c('SalesVolumeThresholdsPanel', {
    attrs: {
      "panel-open": _vm.showSalesConfigurePanel,
      "thresholds-api-base": _vm.salesVolumeThresholdsApiBaseUrl,
      "seller-account-id": _vm.stockThresholdSellerAccountId
    },
    on: {
      "close": _vm.closeSalesConfigurePanel,
      "saved": _vm.onSalesVolumePanelSaved,
      "thresholds-load-complete": _vm.onSalesVolumeThresholdsLoadComplete
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    ref: "issuesListScroll",
    staticClass: "issues-category-list",
    on: {
      "&scroll": function($event) {
        return _vm.onIssuesListScroll.apply(null, arguments)
      }
    }
  }, [(_vm.displayedItems.length > 0) ? _c('div', {
    staticClass: "issues-category-list-head",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "issues-col-product"
  }, [_vm._v("Product")]), _vm._v(" "), _c('span', {
    staticClass: "issues-col-marketplace"
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('span', {
    staticClass: "issues-col-change"
  }, [_vm._v("Change")]), _vm._v(" "), _c('span', {
    staticClass: "issues-col-date"
  }, [_vm._v("Date")])]) : _vm._e(), _vm._v(" "), (_vm.listVirtualPadTop > 0) ? _c('div', {
    staticClass: "issues-list-virtual-spacer",
    style: ({
      height: _vm.listVirtualPadTop + 'px'
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.windowedDisplayedItems), function(item) {
    return _c('IssuesCategoryCard', {
      key: item.watchDogItemId || item.watchDogId,
      attrs: {
        "item": item,
        "wdtype": _vm.wdtype,
        "issues-list-tab": _vm.issuesListTab,
        "products": _vm.products,
        "status-label": _vm.getStatusLabel(item),
        "status-class": _vm.getStatusClass(item),
        "api-base-url": _vm.alertThresholdsApiBaseUrl,
        "stock-alert-thresholds-api-base-url": _vm.stockAlertThresholdsApiBaseUrl,
        "sales-volume-thresholds-api-base-url": _vm.salesVolumeThresholdsApiBaseUrl,
        "seller-account-id-for-thresholds": _vm.stockThresholdSellerAccountId,
        "mark-resolve-busy": !!_vm.markResolveBusyIds[item.watchDogId],
        "highlighted-alert-id": _vm.highlightedAlertId,
        "filter-by-market": _vm.filterByMarket
      },
      on: {
        "mute": _vm.muteItem,
        "view-product": _vm.viewProduct,
        "saved": _vm.onAlertThresholdsSaved,
        "mark-resolved": _vm.markItemResolved,
        "filter-marketplace": _vm.onMarketplaceChipFilter
      }
    })
  }), _vm._v(" "), (_vm.listVirtualPadBottom > 0) ? _c('div', {
    staticClass: "issues-list-virtual-spacer",
    style: ({
      height: _vm.listVirtualPadBottom + 'px'
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsLoading && _vm.displayedItems.length === 0) ? _c('div', {
    staticClass: "issues-category-empty"
  }, [_vm._v("\n      Loading alerts…\n    ")]) : (_vm.displayedItems.length === 0) ? _c('div', {
    staticClass: "issues-category-empty"
  }, [(_vm.issuesListTab === 'active') ? [_vm._v("No current alerts")] : [_vm._v("No resolved issues")]], 2) : _vm._e(), _vm._v(" "), (_vm.itemsMeta && _vm.itemsMeta.total_pages > 1) ? _c('div', {
    staticClass: "issues-category-pager"
  }, [_c('button', {
    staticClass: "issues-category-pager-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.itemsMeta.page <= 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('issues-page-change', _vm.itemsMeta.page - 1)
      }
    }
  }, [_vm._v("Previous")]), _vm._v(" "), _c('span', [_vm._v("Page " + _vm._s(_vm.itemsMeta.page) + " of " + _vm._s(_vm.itemsMeta.total_pages))]), _vm._v(" "), _c('button', {
    staticClass: "issues-category-pager-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.itemsMeta.page >= _vm.itemsMeta.total_pages
    },
    on: {
      "click": function($event) {
        return _vm.$emit('issues-page-change', _vm.itemsMeta.page + 1)
      }
    }
  }, [_vm._v("Next")])]) : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3147bcff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/issues/IssuesCategoryDetail.vue
// module id = 743
// module chunks = 2